module.exports = __webpack_public_path__ + "img/g5.930d085e.jpg";